<div class="message-actions" *ngIf="!isTyping">
  <ng-container *ngIf="isAssistant">
    <button
      nz-button
      nzType="text"
      nzSize="small"
      class="action-btn"
      [disabled]="isBusy"
      [attr.aria-pressed]="isPositiveFeedback === true"
      (click)="onLikeClick()"
      title="Like"
      aria-label="Like"
    >
      <svg-icon class="importIcon" [src]="isPositiveFeedback !== true ? 'assets/icons/like.svg' : 'assets/icons/likeFill.svg'" aria-hidden="true" />
    </button>
    <button
      nz-button
      nzType="text"
      nzSize="small"
      class="action-btn"
      [disabled]="isBusy"
      [attr.aria-pressed]="isPositiveFeedback === false"
      (click)="onDislikeClick()"
      title="Dislike"
      aria-label="Dislike"
    >
      <svg-icon class="importIcon" [src]="isPositiveFeedback === false ? 'assets/icons/dislikeFill.svg' : 'assets/icons/dislike.svg'" aria-hidden="true" />
    </button>
  </ng-container>
  <button nz-button nzType="text" nzSize="small" class="action-btn" (click)="onCopy()" title="Copy" aria-label="Copy">
    <svg-icon class="importIcon" src="assets/icons/copyText.svg" aria-hidden="true" />
  </button>
</div>

<ng-template #likeFeedbackModalTpl>
  <div class="like-feedback-modal-body">
    <span class="feedback-field-label">Feedback</span>
    <gains-input label="Details (Optional)" class="feedback-input" [customFormControl]="likeFeedbackControl" [showErrorMessage]="false"></gains-input>

    <div class="feedback-actions">
      <button class="feedback-btns" nz-button nzType="default" (click)="onLikeFeedbackCancel()">Cancel</button>
      <button class="feedback-btns" nz-button nzType="primary" (click)="onLikeFeedbackSubmit()">Submit</button>
    </div>
  </div>
</ng-template>

<ng-template #dislikeFeedbackModalTpl>
  <div class="dislike-feedback-modal-body">
    <span class="feedback-field-label">Feedback</span>
    <gains-select
      class="feedback-select"
      [customFormControl]="dislikeFeedbackTypeControl"
      [items]="feedbackTypes"
      mode="default"
      placeholder="Select type"
      label="Type of Issue"
    ></gains-select>

    <gains-input label="Details (Optional)" class="feedback-input" [customFormControl]="dislikeFeedbackDetailsControl" [showErrorMessage]="false"></gains-input>

    <div class="feedback-actions">
      <button class="feedback-btns" nz-button nzType="default" (click)="onDislikeFeedbackCancel()">Cancel</button>
      <button class="feedback-btns" nz-button nzType="primary" (click)="onDislikeFeedbackSubmit()">Submit</button>
    </div>
  </div>
</ng-template>
